var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRocket = function SvgRocket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9.76 17.595c-1.06 3.182-5.303 3.182-5.303 3.182s0-4.243 3.182-5.304M19.306 10.17l-6.364 6.364-4.243-4.242 6.364-6.364c2.41-2.41 4.82-2.387 5.847-2.233a.75.75 0 0 1 .629.628c.153 1.028.177 3.437-2.233 5.847"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M18.245 11.23v6.054a.75.75 0 0 1-.22.53l-3.032 3.033a.75.75 0 0 1-1.266-.384l-.786-3.929M14.001 6.988H7.948a.75.75 0 0 0-.53.22L4.386 10.24a.75.75 0 0 0 .383 1.266l3.93.786"
  })));
};
export default SvgRocket;